import base from "./base"

async function getStores(searchString) {
    return await base.httpReq(
        false,
        "get",
        `/store/`,
        null,
        {searchString}
    )
}

async function getStoreInfo(account) {
    return await base.httpReq(
        false,
        "get",
        `/store/info`,
        null,
        {account}
    )
}

async function getStoreProfile(account) {
    return await base.httpReq(
        false,
        "get",
        `/store/profile`,
        null,
        {account}
    )
}

async function updateStoreProfile(profile) {
    return await base.httpReq(
        true,
        "post",
        `/store/profile`,
        profile,
        null
    )
}

async function getStorePaymentEvents(account) {
    return await base.httpReq(
        true,
        "get",
        `/store/paymentEvents`,
        null,
        {account}
    )
}

async function getCustomerEvents(storeAccount, customerAccount) {
    return await base.httpReq(
        true,
        "get",
        `/store/customerEvents`,
        null,
        {storeAccount, customerAccount}
    )
}

export default {
    getStores,
    getStoreInfo,
    getStoreProfile,
    updateStoreProfile,
    getStorePaymentEvents,
    getCustomerEvents
}